import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminSEOSettings = () => {
  const [form, setForm] = useState({
    site_title: "",
    tagline: "",
    default_meta_description: "",
    default_keywords: [],
    og_image: "",
    twitter_handle: "",
    facebook_url: "",
    linkedin_url: "",
    instagram_url: "",
    youtube_url: "",
  });

  const load = async () => {
    try {
      const res = await api.get("/seo/settings");
      setForm({
        site_title: res.data?.site_title || "",
        tagline: res.data?.tagline || "",
        default_meta_description: res.data?.default_meta_description || "",
        default_keywords: res.data?.default_keywords || [],
        og_image: res.data?.og_image || "",
        twitter_handle: res.data?.twitter_handle || "",
        facebook_url: res.data?.facebook_url || "",
        linkedin_url: res.data?.linkedin_url || "",
        instagram_url: res.data?.instagram_url || "",
        youtube_url: res.data?.youtube_url || "",
      });
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to load SEO settings");
    }
  };

  const save = async (e) => {
    e.preventDefault();

    try {
      await api.put("/seo/settings", form);
      toast.success("SEO settings saved");
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to save SEO settings");
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Global SEO Settings
      </h1>

      <form
        onSubmit={save}
        className="bg-white rounded-3xl border p-6 grid md:grid-cols-2 gap-5"
      >
        <label>
          <span className="font-bold text-sm">Site Title</span>
          <input
            value={form.site_title}
            onChange={(e) => setForm({ ...form, site_title: e.target.value })}
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">Tagline</span>
          <input
            value={form.tagline}
            onChange={(e) => setForm({ ...form, tagline: e.target.value })}
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label className="md:col-span-2">
          <span className="font-bold text-sm">Default Meta Description</span>
          <textarea
            value={form.default_meta_description}
            maxLength={160}
            onChange={(e) =>
              setForm({ ...form, default_meta_description: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
            rows="3"
          />
          <small>{form.default_meta_description?.length || 0}/160</small>
        </label>

        <label>
          <span className="font-bold text-sm">Default Keywords</span>
          <input
            value={form.default_keywords?.join(", ") || ""}
            onChange={(e) =>
              setForm({
                ...form,
                default_keywords: e.target.value
                  .split(",")
                  .map((k) => k.trim())
                  .filter(Boolean),
              })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">Twitter / X Handle</span>
          <input
            value={form.twitter_handle}
            onChange={(e) =>
              setForm({ ...form, twitter_handle: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">Facebook URL</span>
          <input
            value={form.facebook_url}
            onChange={(e) =>
              setForm({ ...form, facebook_url: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">LinkedIn URL</span>
          <input
            value={form.linkedin_url}
            onChange={(e) =>
              setForm({ ...form, linkedin_url: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">Instagram URL</span>
          <input
            value={form.instagram_url}
            onChange={(e) =>
              setForm({ ...form, instagram_url: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label>
          <span className="font-bold text-sm">YouTube URL</span>
          <input
            value={form.youtube_url}
            onChange={(e) =>
              setForm({ ...form, youtube_url: e.target.value })
            }
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <label className="md:col-span-2">
          <span className="font-bold text-sm">OG Image URL</span>
          <input
            value={form.og_image}
            onChange={(e) => setForm({ ...form, og_image: e.target.value })}
            className="mt-2 w-full border rounded-2xl px-4 py-3"
          />
        </label>

        <button className="md:col-span-2 py-4 rounded-2xl bg-[#0b6b1d] text-white font-black">
          Save SEO Settings
        </button>
      </form>
    </section>
  );
};

export default AdminSEOSettings;